import { createRoute, Outlet } from "@tanstack/react-router";
import { Route as authenticatedRoute } from "../_authenticated";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import { useAuth } from "@/hooks/useAuth";
import { useDashboardPrefetch } from "@/hooks/useDashboardPrefetch";

function DashboardWrapper() {
  const { backendToken } = useAuth();
  useDashboardPrefetch(backendToken);

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "dashboard",
  component: DashboardWrapper,
});
